import { render, staticRenderFns } from "./WebsiteWizardKeyVisualsForm.vue?vue&type=template&id=48e48483&scoped=true&"
import script from "./WebsiteWizardKeyVisualsForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteWizardKeyVisualsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e48483",
  null
  
)

export default component.exports